import { useState } from "react";
import { ShieldCheck, Lock, User } from "@phosphor-icons/react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import Spinner from "@/components/Spinner";
import { useAdminAuth } from "@/context/AdminAuthContext";
import AdminDashboard from "@/pages/AdminDashboard";

function AdminLoginScreen() {
  const { login } = useAdminAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Sesión de administrador iniciada");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Credenciales inválidas");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="admin-login-screen">
      <div className="w-full max-w-md bg-card border border-border rounded-md p-8">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-md bg-primary text-primary-foreground grid place-items-center">
            <ShieldCheck size={26} weight="duotone" />
          </div>
          <div>
            <div className="overline">Recobro · Admin</div>
            <h1 className="font-heading text-2xl font-semibold tracking-tight">Panel de Administración</h1>
          </div>
        </div>
        <p className="text-sm text-muted-foreground mb-6">
          Acceso exclusivo para super-administradores. Esta ruta es independiente del login de usuarios.
        </p>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <div>
            <Label htmlFor="ae">Correo</Label>
            <div className="relative">
              <User size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
              <Input id="ae" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-email" className="pl-9" />
            </div>
          </div>
          <div>
            <Label htmlFor="ap">Contraseña</Label>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
              <Input id="ap" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-password" className="pl-9" />
            </div>
          </div>
          <Button type="submit" className="w-full" disabled={busy} data-testid="admin-submit">
            {busy ? <Spinner size="s" className="mr-2" /> : <ShieldCheck size={16} weight="bold" className="mr-2" />}
            {busy ? "Verificando…" : "Acceder al panel"}
          </Button>
        </form>
      </div>
    </div>
  );
}

export default function AdminPage() {
  const { admin, loading } = useAdminAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-muted-foreground">Cargando panel…</div>;
  if (!admin) return <AdminLoginScreen />;
  return <AdminDashboard />;
}
